export const routerData = {
	appRouter:{
		title:'游戏',
		id:'gameMenu',
		data: [
			// {
			// 	routerName:'游戏名称',
			// 	routerParams:'game', // 与文件同名
			// 	id:'game'
			// },
			{
				routerName:'荣耀2048',
				routerParams:'xy2048', // 与文件同名
				id:'xy2048'
			},
			{
				routerName:'深海飞鱼',
				routerParams:'shapefLy', // 与文件同名
				id:'shapefLy'
			},
			{
				routerName:'荣耀国际象棋',
				routerParams:'chess', // 与文件同名
				id:'chess'
			},
			{
				routerName:'荣耀五子棋',
				routerParams:'goBang', // 与文件同名
				id:'goBang'
			},
			{
				routerName:'赛车大神',
				routerParams:'carGold', // 与文件同名 
				id:'carGold'
			},{
				routerName:'拯救西兰花',
				routerParams:'saveFlower', // 与文件同名
				id:'saveFlower'
			},
			{
				routerName:'缤纷连连球',
				routerParams:'colorBoll', // 与文件同名
				id:'colorBoll'
			},
			{
				routerName:'梦圆游戏合集官网',
				routerParams:'dreamCollection', // 与文件同名
				id:'dreamCollection'
			}
		],
	},
	gameRouter:{
		title:'应用',
		id:'officalMenu',
		data: [
			// {
			// 	routerName:'应用名称',
			// 	routerParams:'offical', // 与文件同名
			// 	id:'offical'
			// },
			{
				routerName:'小白记账',
				routerParams:'accounts', // 与文件同名
				id:'accounts'
			},
			{
				routerName:'考拉习惯',
				routerParams:'habit', // 与文件同名
				id:'habit'
			},
			{
				routerName:'心心健康',
				routerParams:'xinxinHealth', // 与文件同名
				id:'xinxinHealth'
			},
			{
				routerName:'安全密码',
				routerParams:'safePassword', // 与文件同名
				id:'safePassword'
			},
			{
				routerName:'节食日记',
				routerParams:'xy_dailyeat', // 与文件同名
				id:'xy_dailyeat'
			},
			{
				routerName:'融通助理',
				routerParams:'accommodationAssistant', // 与文件同名
				id:'accommodationAssistant'
			},
			{
				routerName:'青柠时刻',
				routerParams:'limeMoment', // 与文件同名
				id:'limeMoment'
			}
		],
	},
	agreementRouter: {
		title:'协议',
		id:'document',
		data: [
			{
				routerName:'隐私政策',
				routerParams:'privacy-agreement', // 与文件同名
				id:'privacy-agreement'
			},
			{
				routerName:'服务协议',
				routerParams:'service-agreement', // 与文件同名
				id:'service-agreement'
			}
		]
	}
}